import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import {
  menuRootOptions,
  defaultStackHeaderOptions,
  allowStackToScrollOnWebOption,
} from '../utils/defaultNavOptions';
import AAHomeScreen from '../screens/AmericanAirlines/AAHomeScreen';
import AASearchScreen from '../screens/AmericanAirlines/AASearchScreen';
import MeScreen from '../screens/MeScreen';
import HomeScreen from '../screens/HomeScreen';
import { Screens } from '../constants/ScreenNames';
import { AA_ENABLED, EVENTS_ENABLED, CREW_ENABLED } from '../config/env';
import EventHomeScreen from '../screens/Events/EventHomeScreen';
import { selectUserProfileImage } from '../store/selectors/profile.selector';
import { useSelector } from 'react-redux';
import { useNavigation } from '@react-navigation/native';

const HomeStackNavigator = createStackNavigator();
export const HomeNavigator = () => {
  const userImage = useSelector(selectUserProfileImage);
  const navigation = useNavigation();
  return (
    <HomeStackNavigator.Navigator
      screenOptions={{ ...defaultStackHeaderOptions, ...allowStackToScrollOnWebOption }}
    >
      {EVENTS_ENABLED && (
        <HomeStackNavigator.Screen
          name={Screens.EventHome}
          component={EventHomeScreen}
          options={menuRootOptions}
        />
      )}

      {AA_ENABLED ? (
        <>
          <HomeStackNavigator.Screen
            name={Screens.AAHome}
            component={AAHomeScreen}
            options={menuRootOptions}
          />
          <HomeStackNavigator.Screen
            name={Screens.AASearchScreen}
            component={AASearchScreen}
            options={menuRootOptions}
          />
        </>
      ) : CREW_ENABLED ? (
        <HomeStackNavigator.Screen
          name={Screens.Home}
          component={MeScreen}
          options={menuRootOptions}
        />
      ) : (
        //Means that we are in TEZ APP
        <HomeStackNavigator.Screen
          name={Screens.Home}
          component={HomeScreen}
          options={menuRootOptions({ userImage, navigation })}
        />
      )}
    </HomeStackNavigator.Navigator>
  );
};
